// OT-3 (Dokumanlar/Guvenlik/COKLU-OTURUM-PLANI.md §3.4): aynı tarayıcıdaki sekmeler arası oturum eşitleme.
// localStorage ortak: bir sekme çıkış yapınca ya da başka hesapla girince öbür sekmeler `storage` olayıyla
// öğrenir. Aynı hesabın yenilenen anahtarı sessizce bu sekmenin belleğine alınır (bayat anahtarla 401 olmasın).
// Erişim anahtarı opak (JWT değil) — hangi hesaba ait olduğu girişte yazılan `oturumHesap` anahtarından okunur.
import { sirketeGecSekmesi } from './depo';
import { UserData } from '../store/user.store';
import { esPublicYolMu } from './rotaMuafiyet';
import { defteriBosalt } from './kirliKayit';

const HESAP = 'oturumHesap';
let benimHesap = null;   // bu sekmedeki oturumun kullanıcı adı
let kilitli = false;     // "başka hesap" katmanı açık → bu sekme istek atmaz
let baslatildi = false;

export function oturumKilitliMi() {
  return kilitli;
}

// Bu sekmede giriş yapılınca çağrılır — token yazılmadan ÖNCE (öbür sekme token olayında yeni hesabı okusun).
// storage olayı yazan sekmeye gelmez; bu yüzden sekmenin kendi değeri de burada güncellenir.
export function hesapYaz(kullaniciAd) {
  benimHesap = kullaniciAd || null;
  try {
    if (benimHesap) localStorage.setItem(HESAP, benimHesap);
    else localStorage.removeItem(HESAP);
  } catch (e) { /* 3. taraf iframe */ }
}

function ortakHesap() {
  try { return localStorage.getItem(HESAP); } catch (e) { return null; }
}

function publicSayfada() {
  const p = (window.location.pathname || '').toLowerCase();
  return p === '/auth/login' || esPublicYolMu(p, p + window.location.search);
}

function oturumKapandi() {
  UserData.commit('_TOKEN', null);
  if (publicSayfada()) return;
  kilitli = true;
  defteriBosalt(); // oturum zaten yok — kaydedilmemiş değişiklik sorusu anlamsız
  try { sessionStorage.setItem('girisBildirim', 'Bu tarayıcıda oturum kapatıldı.'); } catch (e) { /* yoksay */ }
  window.location.href = '/auth/login';
}

// OT-3e (G-18): yerel oturum silinince bu sekme de oturum dışı ekrana gider. Görünür sekmede router ile
// (hedef: Oturum süresi bitti ekranı), arka plandaki sekmede tam yükleme ile giriş ekranı — gizli sekmede
// router geçişi rAF beklediği için donuyordu ve sekme ekranda kalıyordu (bkz. gizli sekme geçiş donması).
export function buSekmeyiOturumDisinaAl(router, hedef) {
  UserData.commit('_TOKEN', null);
  const yol = (window.location.pathname || '').toLowerCase();
  if (yol === '/auth/login' || yol === '/oturum-suresi-bitti') return;
  if (publicSayfada()) return;
  defteriBosalt();
  if (document.hidden || !router) {
    kilitli = true;
    try { sessionStorage.setItem('girisBildirim', 'Bu tarayıcıda oturum kapatıldı.'); } catch (e) { /* yoksay */ }
    window.location.href = '/auth/login';
    return;
  }
  router.push(hedef);
}

function hesapDegisti(ad) {
  kilitli = true;
  defteriBosalt();
  if (document.getElementById('oturum-hesap-degisti')) return;
  const koyu = document.documentElement.classList.contains('dark');
  const katman = document.createElement('div');
  katman.id = 'oturum-hesap-degisti';
  katman.setAttribute('role', 'alertdialog');
  katman.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;' +
    'padding:16px;background:rgba(15,23,42,.72);backdrop-filter:blur(3px);';
  const kart = document.createElement('div');
  kart.style.cssText = 'max-width:420px;width:100%;border-radius:16px;padding:24px;text-align:center;box-shadow:0 20px 50px rgba(0,0,0,.35);' +
    (koyu ? 'background:#1e293b;color:#f1f5f9;' : 'background:#fff;color:#1f2937;');
  const ikon = document.createElement('i');
  ikon.className = 'pi pi-users';
  ikon.style.cssText = 'font-size:2rem;color:#14b8a6;margin-bottom:12px;display:block;';
  const metin = document.createElement('p');
  metin.style.cssText = 'font-size:1rem;font-weight:600;margin:0 0 6px;';
  metin.textContent = 'Bu tarayıcıda başka bir hesapla (' + ad + ') giriş yapıldı.';
  const alt = document.createElement('p');
  alt.style.cssText = 'font-size:.875rem;margin:0 0 18px;opacity:.75;';
  alt.textContent = 'Bu sekmedeki oturum artık geçerli değil. Sayfayı yenileyince yeni hesapla devam eder.';
  const dugme = document.createElement('button');
  dugme.type = 'button';
  dugme.textContent = 'Sayfayı yenile';
  dugme.style.cssText = 'width:100%;padding:10px 16px;border:0;border-radius:12px;font-weight:600;cursor:pointer;color:#fff;background:#0d9488;';
  dugme.addEventListener('click', () => window.location.reload());
  kart.append(ikon, metin, alt, dugme);
  katman.appendChild(kart);
  document.body.appendChild(katman);
  dugme.focus();
}

function dinle(e) {
  try {
    if (e.storageArea && e.storageArea !== localStorage) return;
  } catch (err) { return; }
  if (kilitli) return;

  // localStorage.clear() → key null
  if (e.key === null || e.key === 'token') {
    const yeni = e.key === null ? null : e.newValue;
    if (!yeni) {
      if (e.key === null || e.oldValue) oturumKapandi();
      return;
    }
    if (sirketeGecSekmesi()) return; // bu sekmenin anahtarı ayrı (Şirkete geç)
    const hesap = ortakHesap();
    if (benimHesap && hesap && hesap !== benimHesap && !publicSayfada()) {
      hesapDegisti(hesap);
      return;
    }
    if (hesap) benimHesap = hesap;
    UserData.commit('_TOKEN', yeni);
    return;
  }
  if (sirketeGecSekmesi() || !e.newValue) return;
  if (e.key === 'tokenExpiration') UserData.commit('_TOKEN_EXPIRATION', e.newValue);
  else if (e.key === 'refreshToken') UserData.commit('_REFRESH_TOKEN', e.newValue);
}

export function oturumSenkronBaslat() {
  if (baslatildi || typeof window === 'undefined') return;
  baslatildi = true;
  benimHesap = ortakHesap();
  window.addEventListener('storage', dinle);
}

// Giriş ekranı: başka sekmenin bıraktığı bildirim (bir kez gösterilir).
export function girisBildirimiAl() {
  try {
    const m = sessionStorage.getItem('girisBildirim');
    if (m) sessionStorage.removeItem('girisBildirim');
    return m;
  } catch (e) { return null; }
}

// 401 "oturum başka yerden kapatıldı" (OT-2 OturumGecerliFiltre). Özel başlık çapraz kökende
// görünmeyebilir; gövde de aynı bilgiyi taşır.
export function oturumKapatildiMi(res) {
  if (!res || res.status !== 401) return false;
  const h = res.headers ? (res.headers['x-oturum'] || (res.headers.get && res.headers.get('x-oturum'))) : null;
  if (h === 'kapatildi') return true;
  return !!(res.data && typeof res.data === 'object' && res.data.Oturum === 'kapatildi');
}

export default { oturumSenkronBaslat, oturumKilitliMi, hesapYaz, girisBildirimiAl, oturumKapatildiMi };
